import { render, staticRenderFns } from "./createCode.vue?vue&type=template&id=1b460fe4&scoped=true"
import script from "./createCode.vue?vue&type=script&lang=js"
export * from "./createCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b460fe4",
  null
  
)

export default component.exports